// extracted by mini-css-extract-plugin
export var componentHeader = "template-module--componentHeader--TiPum";
export var content = "template-module--content--GpNmY";
export var current = "template-module--current--hH7d2";
export var headerH1 = "template-module--headerH1--j9Swg";
export var markdown = "template-module--markdown--KMLyz";
export var midContent = "template-module--midContent--vB-8n";
export var midHeader = "template-module--midHeader---YLyg";
export var midWrapper = "template-module--midWrapper--viGJk";
export var sidebar = "template-module--sidebar--X2WG+";
export var specHeader = "template-module--specHeader--wWBSg";
export var tabs = "template-module--tabs--b5S6n";
export var toc = "template-module--toc--9gaN4";
export var wrapper = "template-module--wrapper--eNBqo";